module.exports = __webpack_public_path__ + "static/media/Лискина_Алыпов_(ММ).8f2253f2.pdf";